export enum Client {
  Core = 'core',
  Android = 'publishAndroid',
  Ios = 'publishIos',
  PublishWeb = 'publishWeb',
}
